export default "__VITE_ASSET__CIGOeJQo__"